/* nr-search-predictive.js
   Live predictive product results for the site's two search inputs:
     1. The mobile drawer's INLINE search (#mobile-menu-drawer .nrmd-search__input)
        — type and results appear right inside the drawer, no popup.
     2. The header search modal (#nr-search-panel input[name="q"]) — the panel that
        the 2026-06-10 scroll-lock fix opens instead of Focal's predictive drawer.

   Both query Shopify's /search/suggest.json and render the same .nr-psr markup,
   which is styled per-context (dark inside the drawer, light inside the panel).
   Additive only — never opens/closes a drawer or touches the scroll lock. */
(function () {
  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 2;
  var LIMIT = 6;
  var INPUT_SELECTOR = '#mobile-menu-drawer .nrmd-search__input, #nr-search-panel input[name="q"]';
  var timer = null;
  var lastTerm = '';

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(value) {
    if (value == null || value === '') return '';
    var n = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  /* Where the results list lives for a given input. */
  function mountFor(input) {
    var panel = input.closest('#nr-search-panel');
    if (panel) return panel.querySelector('.nr-search-panel__box') || panel;
    var drawer = input.closest('.nrmd-search');
    if (drawer) return drawer;
    return null;
  }

  function ensureResults(mount) {
    var el = mount.querySelector('.nr-psr');
    if (!el) {
      el = document.createElement('div');
      el.className = 'nr-psr';
      el.setAttribute('aria-live', 'polite');
      mount.appendChild(el);
    }
    return el;
  }

  function render(mount, products, term) {
    var el = ensureResults(mount);
    if (!term || term.length < MIN_CHARS) { el.innerHTML = ''; return; }
    if (!products.length) {
      el.innerHTML = '<p class="nr-psr__empty">No matches for &ldquo;' + esc(term) + '&rdquo; yet&hellip;</p>';
      return;
    }
    var items = products.slice(0, LIMIT).map(function (p) {
      var img = p.image
        ? '<img class="nr-psr__img" src="' + esc(p.image) + '" alt="" loading="lazy" width="52" height="52">'
        : '<span class="nr-psr__img nr-psr__img--blank"></span>';
      var price = money(p.price);
      var priceHtml = price ? '<span class="nr-psr__price">' + price + '</span>' : '';
      return '<a class="nr-psr__item" href="' + esc(p.url) + '">' + img +
        '<span class="nr-psr__text"><span class="nr-psr__title">' + esc(p.title) + '</span>' + priceHtml + '</span></a>';
    }).join('');
    var viewAll = '<a class="nr-psr__viewall" href="' + root() +
      '/search?q=' + encodeURIComponent(term) + '&type=product">View all results for &ldquo;' + esc(term) + '&rdquo;</a>';
    el.innerHTML = items + viewAll;
  }

  function queryFor(mount, term) {
    var url = root() + '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (term !== lastTerm) return; /* a newer keystroke superseded this one */
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        render(mount, products, term);
      })
      .catch(function () { /* network hiccup — keep the last good results */ });
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(INPUT_SELECTOR)) return;
    var mount = mountFor(t);
    if (!mount) return;
    var term = (t.value || '').trim();
    lastTerm = term;
    clearTimeout(timer);
    if (term.length < MIN_CHARS) { render(mount, [], term); return; }
    timer = setTimeout(function () { queryFor(mount, term); }, DEBOUNCE_MS);
  });
})();
